import { Alert } from '@zillow/constellation-10';

interface WizardAlertProps {
  serverErrorObj: { displayAt: string; displayMessage: string };
  displayAt: string;
}

const WizardAlert = ({ serverErrorObj, displayAt }: WizardAlertProps): JSX.Element | null => {
  return serverErrorObj.displayMessage && serverErrorObj.displayAt === displayAt ? (
    <Alert data-testid="WizardAlert" tone="critical" css={{ marginBottom: '600' }}>
      <div dangerouslySetInnerHTML={{ __html: serverErrorObj.displayMessage }} />
    </Alert>
  ) : null;
};

export default WizardAlert;
